export default {
    "ТЭИ: Стардартный отчет": "standard",
    "ТЭИ: Экспертный отчет": "full",
    "ТЭИ: Управленческий потенциал": "management",
    "ТЭИ: Отчет для исследований": "empty"
}